const read_count = (value) => {
    const count = Number(value);

    return Number.isFinite(count) ? Math.max(count, 0) : 0;
};

// Resolves the backward-compatible Quest total and its provider breakdown.
export const read_quest_provider_counts = (brand = {}) => {
    const questCounts = brand?.questCounts || {};
    const history = brand?.questClientHistory?.canonical === true ? brand.questClientHistory : null;
    const google = {
        active: read_count(questCounts?.byProvider?.google?.active),
        inactive: read_count(questCounts?.byProvider?.google?.inactive)
    };
    const hasProviderCounts = Boolean(questCounts?.byProvider?.meta || questCounts?.byProvider?.google);
    const savedActive = read_count(questCounts.active ?? brand?.activeQuestCount);
    const savedInactive = read_count(questCounts.inactive ?? brand?.inactiveQuestCount);
    const exactMeta = {
        active: hasProviderCounts ? read_count(questCounts?.byProvider?.meta?.active) : Math.max(savedActive - google.active, 0),
        inactive: hasProviderCounts ? read_count(questCounts?.byProvider?.meta?.inactive) : Math.max(savedInactive - google.inactive, 0)
    };
    const meta = history ? {
        active: read_count(history.active),
        inactive: read_count(history.inactive)
    } : exactMeta;
    const byProvider = {
        meta: { ...meta, total: meta.active + meta.inactive },
        google: { ...google, total: google.active + google.inactive }
    };
    const active = meta.active + google.active;
    const inactive = meta.inactive + google.inactive;

    return {
        active,
        inactive,
        total: active + inactive,
        byProvider
    };
};
